export const yamahaMtxModelNames = {
    '-OQ9zFMwEf1_JaA7bCOJ': 'mtx3',
    '-OQ9zIuDmJv-h8HOdrY5': 'mtx5d',
};
const debug = false;
// Used to determine whether a set/get has valid syntax and corresponds to a mute or volume.
const YamahaProductInfo = {
    mtx3: {
        automixer: {
            mute: [{ uniqueId: 50011, paramNo: 1, xPos: 0, yPosRange: { min: 0, max: 1 } }],
        },
        crossPoint: {
            //TODO: Support stereo cross points?
            mute: [
                {
                    uniqueId: 30002,
                    elmNo: 1,
                    paramNo: 1,
                    xPosRange: { min: 0, max: 25 },
                    yPosRange: { min: 0, max: 7 },
                    xPosStereoPairs: [
                        [8, 9],
                        [10, 11],
                        [12, 13],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 30002,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 25 },
                    yPosRange: { min: 0, max: 7 },
                },
            ],
        },
        effectReturn: {
            mute: [
                {
                    uniqueId: 20014,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 3 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [0, 1],
                        [2, 3],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 20014,
                    xPosRange: { min: 0, max: 3 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [0, 1],
                        [2, 3],
                    ],
                },
            ],
        },
        // No groups
        input: {
            mute: [
                {
                    uniqueId: 60001,
                    xPosRange: { min: 0, max: 21 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [8, 9],
                        [10, 11],
                        [12, 13],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 60000,
                    xPosRange: { min: 0, max: 21 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [8, 9],
                        [10, 11],
                        [12, 13],
                    ],
                },
            ],
        },
        inputPatch: {
            mute: [{ uniqueId: 20001, xPos: 0, yPosRange: { min: 0, max: 21 } }],
        },
        output: {
            mute: [
                {
                    uniqueId: 20017,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 7 },
                    yPos: 0,
                },
            ],
            volume: [{ uniqueId: 20017, xPosRange: { min: 0, max: 15 }, yPos: 0 }],
        },
        router: {
            mute: [{ uniqueId: 20023, xPos: 0, yPosRange: { min: 0, max: 15 } }],
            // no volume control
        },
        zone: {
            mute: [{ uniqueId: 60003, xPosRange: { min: 0, max: 7 }, yPos: 0 }],
            volume: [{ uniqueId: 60002, xPosRange: { min: 0, max: 7 }, yPos: 0 }],
        },
    },
    mtx5d: {
        automixer: {
            mute: [{ uniqueId: 50011, paramNo: 1, xPos: 0, yPosRange: { min: 0, max: 3 } }],
        },
        crossPoint: {
            //TODO: Support stereo cross points?
            mute: [
                {
                    uniqueId: 30002,
                    elmNo: 1,
                    paramNo: 1,
                    xPosRange: { min: 0, max: 33 },
                    yPosRange: { min: 0, max: 15 },
                    xPosStereoPairs: [
                        [16, 17],
                        [18, 19],
                        [20, 21],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 30002,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 33 },
                    yPosRange: { min: 0, max: 15 },
                },
            ],
        },
        effectReturn: {
            mute: [
                {
                    uniqueId: 20014,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 3 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [0, 1],
                        [2, 3],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 20014,
                    xPosRange: { min: 0, max: 3 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [0, 1],
                        [2, 3],
                    ],
                },
            ],
        },
        group: {
            mute: [
                {
                    uniqueId: 50012,
                    elmNo: 9,
                    xPosRange: { min: 0, max: 15 },
                    yPosRange: { min: 0, max: 23 },
                },
            ],
        },
        input: {
            mute: [
                {
                    uniqueId: 60001,
                    xPosRange: { min: 0, max: 29 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [16, 17],
                        [18, 19],
                        [20, 21],
                    ],
                },
            ],
            volume: [
                {
                    uniqueId: 60000,
                    xPosRange: { min: 0, max: 29 },
                    yPos: 0,
                    xPosStereoPairs: [
                        [16, 17],
                        [18, 19],
                        [20, 21],
                    ],
                },
            ],
        },
        inputPatch: {
            mute: [
                { uniqueId: 20003, xPos: 0, yPosRange: { min: 0, max: 7 } },
                { uniqueId: 20004, xPos: 0, yPosRange: { min: 0, max: 21 } },
            ],
        },
        output: {
            mute: [
                {
                    uniqueId: 20024,
                    elmNo: 1,
                    xPosRange: { min: 0, max: 15 },
                    yPos: 0,
                },
            ],
            volume: [{ uniqueId: 20024, xPosRange: { min: 0, max: 15 }, yPos: 0 }],
        },
        router: {
            mute: [{ uniqueId: 20023, xPos: 0, yPosRange: { min: 0, max: 15 } }],
            // no volume control
        },
        zone: {
            mute: [{ uniqueId: 60003, xPosRange: { min: 0, max: 15 }, yPos: 0 }],
            volume: [{ uniqueId: 60002, xPosRange: { min: 0, max: 15 }, yPos: 0 }],
        },
    },
};
export class YamahaMtx {
    constructor(socket, log) {
        var _a;
        this.socket = socket;
        this.log = log;
        this.currentPreset = '1';
        this.firmwareVersion = '4.1.5';
        this.params = {};
        this.productModel = 'mtx5d';
        this.serialNumber = 'ZC96670ueeo01014';
        this.valueType = 'raw';
        this.asyncHandlers = [
            {
                regExp: /^devinfo\s+serialno/i,
                callback: (match) => {
                    this.socket.send(`OK devinfo serialno "${this.serialNumber}"`);
                },
            },
            {
                regExp: /^devinfo\s+productname/i,
                callback: (match) => {
                    this.socket.send(`OK devinfo productname "${this.productModel === 'mtx5d' ? 'MTX5-D' : 'MTX3'}"`);
                },
            },
            {
                regExp: /^devinfo\s+version/i,
                callback: (match) => {
                    this.socket.send(`OK devinfo version "${this.firmwareVersion}"`);
                },
            },
            {
                regExp: /^devstatus\s+runmode/i,
                callback: (match) => {
                    this.socket.send(`OK devstatus runmode "normal"`);
                },
            },
            {
                regExp: /^(get)\s+MTX:mem_512\/(\d+\/\d+\/\d+\/\d+\/\d+\/\d+)\s+0\s+0/,
                callback: (match) => {
                    const key = `MTX:mem_512/${match[2]}`;
                    let value = 0;
                    let cmdType = undefined;
                    if (key in this.params) {
                        value = this.params[key].value;
                        cmdType = this.params[key].cmdType;
                    }
                    else {
                        // value hasn't been set yet, so it doesn't exist in this.params
                        [cmdType] = this.getCommandType(match[2]);
                        if (cmdType !== undefined) {
                            // set the default value and save it in this.params
                            value = cmdType === 'mute' ? 1 : 0;
                            this.params[key] = { value, cmdType };
                        }
                    }
                    if (cmdType === 'mute') {
                        this.socket.send(`OK ${match[1]} ${key} 0 0 ${value} "${value === 1 ? 'ON' : 'OFF'}"`);
                    }
                    else if (cmdType === 'volume') {
                        this.socket.send(`OK ${match[1]} ${key} 0 0 ${value} "${value / 100}"`);
                    }
                    else {
                        this.socket.send(`unhandled: ERROR get InternalError`);
                    }
                },
            },
            {
                regExp: /^scpmode\s+valuetype\s+(.+)/i,
                callback: (match) => {
                    // Note: the emulator currently only sends notifications in raw format; changing
                    // this setting doesn't do anything.
                    if (match[1] === 'normalized' || match[1] === 'raw') {
                        this.valueType = match[1];
                        this.socket.send(`OK scpmode valuetype ${this.valueType}`);
                    }
                    this.socket.send(`ERROR scpmode InvalidArgument`);
                },
            },
            {
                regExp: /^(set)\s+MTX:mem_512\/(\d+\/\d+\/\d+\/\d+\/\d+\/\d+)\s+0\s+0\s+(-?[\d\.]+)/,
                callback: (match) => {
                    const key = `MTX:mem_512/${match[2]}`;
                    const value = parseInt(match[3], 10);
                    let cmdType = undefined;
                    let stereoPairCmd;
                    [cmdType, stereoPairCmd] = this.getCommandType(match[2]);
                    if (cmdType !== undefined)
                        this.params[key] = { value, cmdType };
                    // If a stereo pair channel found, update the state of that channel too.
                    if (stereoPairCmd !== undefined && cmdType !== undefined) {
                        this.params[stereoPairCmd] = { value, cmdType };
                    }
                    if (cmdType === 'mute') {
                        this.socket.send(`OK ${match[1]} ${key} 0 0 ${value} "${value === 1 ? 'ON' : 'OFF'}"`);
                        // Stereo channels are linked and send a NOTIFY status if one of the channels
                        // is updated.
                        if (stereoPairCmd) {
                            this.socket.send(`NOTIFY ${match[1]} MTX:mem_512/${stereoPairCmd} 0 0 ${value} "${value === 1 ? 'ON' : 'OFF'}"`);
                        }
                    }
                    else if (cmdType === 'volume') {
                        this.socket.send(`OK ${match[1]} ${key} 0 0 ${value} "${value / 100}"`);
                        if (stereoPairCmd) {
                            this.socket.send(`NOTIFY ${match[1]} MTX:mem_512/${stereoPairCmd} 0 0 ${value} "${value / 100}"`);
                        }
                    }
                    else {
                        this.socket.send(`unhandled: ERROR get InternalError`);
                    }
                },
            },
            {
                regExp: /^sscurrent/i,
                callback: (match) => {
                    this.currentPreset = match[1];
                    this.socket.send(`OK ssrecall ${this.currentPreset} unmodified`);
                },
            },
            {
                regExp: /^ssinfo\s+(\d+)/i,
                callback: (match) => {
                    const pres = match[1];
                    this.socket.send(`OK ssinfo ${pres} "${pres.padStart(2, '0')}" ${pres === '0' ? 'reserve' : 'user'} "Preset ${match[1]}" ""`);
                },
            },
            {
                regExp: /^ssnum/i,
                callback: (match) => {
                    this.currentPreset = match[1];
                    this.socket.send(`OK ssnum 51`);
                },
            },
            {
                regExp: /^ssrecall\s+(\d+)/i,
                callback: (match) => {
                    this.currentPreset = match[1];
                    this.socket.send(`OK ssrecall ${match[1]}`);
                    this.socket.send(`NOTIFY ssrecall ${match[1]}`);
                    this.socket.send(`NOTIFY sscurrent ${match[1]}`);
                },
            },
            {
                regExp: /(.+)/,
                callback: (match) => {
                    this.socket.send(`ERROR ${match[1]} UnknownCommand`);
                },
            },
        ];
        this.productInfo = (_a = YamahaProductInfo === null || YamahaProductInfo === void 0 ? void 0 : YamahaProductInfo[this.productModel]) !== null && _a !== void 0 ? _a : YamahaProductInfo['mtx5d'];
    }
    onConfigure(config) {
        var _a;
        this.productModel = yamahaMtxModelNames[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '-OQ9zIuDmJv-h8HOdrY5'];
        this.productInfo = YamahaProductInfo[this.productModel];
    }
    findStereoChannel(chanIndex, stereoPairs) {
        for (const sp of stereoPairs) {
            if (chanIndex === sp[0])
                return sp[1];
            else if (chanIndex === sp[1])
                return sp[0];
        }
        return undefined;
    }
    // Determine whether the command has the correct syntax, and if so, is a mute or volume command.
    getCommandType(cmdResp, value) {
        let retValue;
        let stereoPairCmd;
        const [uniqueId, elmNo, xPos, yPos, paramNo, indexNo] = cmdResp
            .split('/')
            .map(ele => parseInt(ele, 10));
        for (const val of Object.values(this.productInfo)) {
            for (const [cmdType, commands] of Object.entries(val)) {
                for (const v of commands) {
                    if (v.uniqueId === uniqueId &&
                        (('elmNo' in v && v.elmNo === elmNo) || elmNo === 0) &&
                        (('paramNo' in v && v.paramNo === paramNo) || paramNo === 0) &&
                        (('indexNo' in v && v.indexNo === indexNo) || indexNo === 0) &&
                        (('xPos' in v && v.xPos === xPos) || !('xPos' in v)) &&
                        (('yPos' in v && v.yPos === yPos) || !('yPos' in v)) &&
                        (('xPosRange' in v && xPos <= v.xPosRange.max && xPos >= v.xPosRange.min) ||
                            !('xPosRange' in v)) &&
                        (('yPosRange' in v && yPos <= v.yPosRange.max && yPos >= v.yPosRange.min) ||
                            !('yPosRange' in v)) &&
                        (!('valueRange' in v) ||
                            (value !== undefined &&
                                'valueRange' in v &&
                                value <= v.valueRange.max &&
                                value >= v.valueRange.min))) {
                        if ('xPosStereoPairs' in v) {
                            const otherChan = this.findStereoChannel(xPos, v.xPosStereoPairs);
                            if (otherChan !== undefined) {
                                stereoPairCmd = `${uniqueId}/${elmNo}/${otherChan}/${yPos}/${paramNo}/${indexNo}`;
                            }
                        }
                        if ('yPosStereoPairs' in v) {
                            const otherChan = this.findStereoChannel(yPos, v.yPosStereoPairs);
                            if (otherChan !== undefined) {
                                stereoPairCmd = `${uniqueId}/${elmNo}/${xPos}/${otherChan}/${paramNo}/${indexNo}`;
                            }
                        }
                        retValue = cmdType;
                        break;
                    }
                }
            }
        }
        if (debug)
            this.log.debug(`emulator getCommandType = ${[retValue, stereoPairCmd]}`);
        return [retValue, stereoPairCmd];
    }
}
YamahaMtx.emulatorType = 'socketEmulator';
YamahaMtx.key = '-OQ9z3n5XlrJIpSxd4Y7';
